/**
 * Wire shapes returned by brandon.api's identity context
 * (`api/v1/identity/auth/*`). Kept separate from the UI models — the mapping
 * between the two lives in AuthService.
 */

import { ApiLanguage, ApiRecordStatus } from './api.model';

/** Success envelope the API wraps every 2xx body in. Errors arrive unwrapped. */
export interface ApiEnvelope<T> {
  status: number;
  message: string;
  data: T;
}

/** Mirrors the backend's numeric UserRole enum. */
export enum ApiUserRole {
  Student = 0,
  Teacher = 1,
  Administrator = 2,
  System = 3,
}

/** The client-safe slice of the backend User aggregate that the UI reads. */
export interface ApiPublicUser {
  id: string;
  email: string;
  name?: string;
  avatarUrl?: string;
  roles: ApiUserRole[];
  /** Present on auth/profile payloads; omit treated as active for older sessions. */
  status?: ApiRecordStatus;
  twoFactorEnabled: boolean;
}

/** Latest ACTIVE enrollment returned on login / refresh / register. */
export interface AuthCurrentCourseDto {
  enrollmentId: string;
  curriculumCourseId: string;
  title: string;
  language?: ApiLanguage | null;
  color?: string | null;
  progressPercentage: number;
  enrollmentStatus: number;
}

export interface AuthResultDto {
  accessToken: string;
  refreshToken: string;
  tokenType: 'Bearer';
  expiresIn: number;
  refreshExpiresIn: number;
  user: ApiPublicUser;
  currentCourse?: AuthCurrentCourseDto | null;
}

/** Returned by login instead of tokens when the account has 2FA enabled. */
export interface TwoFactorChallengeDto {
  requiresTwoFactor: true;
  userId: string;
}
